import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteConfirmationModal from '../../HOC/DeleteConfirmationModal/DeleteConfirmationModal';

export interface IDeleteParticipantModal {
  active: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteParticipantModal: FC<IDeleteParticipantModal> = ({ active, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <DeleteConfirmationModal
      active={active}
      actionLabel={t('viewSurvey.participants.modals.delete.actions.confirm')}
      cancelLabel={t('viewSurvey.participants.modals.delete.actions.cancel')}
      title={t('viewSurvey.participants.modals.delete.title')}
      text={t('viewSurvey.participants.modals.delete.text')}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default DeleteParticipantModal;
